import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/edox/access/access_api.proto" (package "grpc.edox.access", syntax proto3)
// tslint:disable
import { AccessApi } from "./access_api_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service grpc.edox.access.AccessApi
 */

export var AccessApiClient = /*#__PURE__*/function () {
  function AccessApiClient(_transport) {
    _classCallCheck(this, AccessApiClient);

    this._transport = _transport;
    this.typeName = AccessApi.typeName;
    this.methods = AccessApi.methods;
    this.options = AccessApi.options;
  }
  /**
   * Проверка регистрации пользователя
   *
   * @generated from protobuf rpc: GetRegistrationInfo(grpc.edox.access.GetRegistrationInfoRequest) returns (grpc.edox.access.GetRegistrationInfoResponse);
   */


  _createClass(AccessApiClient, [{
    key: "getRegistrationInfo",
    value: function getRegistrationInfo(input, options) {
      var method = this.methods[0],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Методы восстановления доступа
     *
     * @generated from protobuf rpc: RequestRestoreAccess(grpc.edox.access.RequestRestoreAccessRequest) returns (google.protobuf.Empty);
     */

  }, {
    key: "requestRestoreAccess",
    value: function requestRestoreAccess(input, options) {
      var method = this.methods[1],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CheckRestoreAccess(grpc.edox.access.CheckRestoreAccessRequest) returns (google.protobuf.Empty);
     */

  }, {
    key: "checkRestoreAccess",
    value: function checkRestoreAccess(input, options) {
      var method = this.methods[2],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ConfirmRestoreAccess(grpc.edox.access.ConfirmRestoreAccessRequest) returns (grpc.edox.access.ConfirmRestoreAccessResponse);
     */

  }, {
    key: "confirmRestoreAccess",
    value: function confirmRestoreAccess(input, options) {
      var method = this.methods[3],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RestoreAccess(grpc.edox.access.RestoreAccessRequest) returns (google.protobuf.Empty);
     */

  }, {
    key: "restoreAccess",
    value: function restoreAccess(input, options) {
      var method = this.methods[4],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Регистрация
     *
     * @deprecated
     * @generated from protobuf rpc: CheckRegistration(grpc.edox.access.CheckRegistrationRequest) returns (grpc.edox.access.CheckRegistrationResponse);
     */

  }, {
    key: "checkRegistration",
    value: function checkRegistration(input, options) {
      var method = this.methods[5],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CheckAccountRegistration(grpc.edox.access.CheckAccountRegistrationRequest) returns (grpc.edox.access.CheckAccountRegistrationResponse);
     */

  }, {
    key: "checkAccountRegistration",
    value: function checkAccountRegistration(input, options) {
      var method = this.methods[6],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @deprecated
     * @generated from protobuf rpc: Register(grpc.edox.access.RegistrationRequest) returns (grpc.edox.access.RegistrationResponse);
     */

  }, {
    key: "register",
    value: function register(input, options) {
      var method = this.methods[7],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RegisterAccount(grpc.edox.access.RegisterAccountRequest) returns (grpc.edox.access.RegisterAccountResponse);
     */

  }, {
    key: "registerAccount",
    value: function registerAccount(input, options) {
      var method = this.methods[8],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ConfirmRegistration(grpc.edox.access.ConfirmRegistrationRequest) returns (google.protobuf.Empty);
     */

  }, {
    key: "confirmRegistration",
    value: function confirmRegistration(input, options) {
      var method = this.methods[9],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @deprecated
     * @generated from protobuf rpc: RenewRegistrationConfirmation(grpc.edox.access.RenewRegistrationConfirmationRequest) returns (grpc.edox.access.RenewRegistrationConfirmationResponse);
     */

  }, {
    key: "renewRegistrationConfirmation",
    value: function renewRegistrationConfirmation(input, options) {
      var method = this.methods[10],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RequestRegistrationConfirmation(grpc.edox.access.RequestRegistrationConfirmationRequest) returns (grpc.edox.access.RequestRegistrationConfirmationResponse);
     */

  }, {
    key: "requestRegistrationConfirmation",
    value: function requestRegistrationConfirmation(input, options) {
      var method = this.methods[11],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Отправляет письмо пользователю для подтверждения почты
     * JWT-Authentication
     *
     * @generated from protobuf rpc: RequestEmailConfirmation(grpc.edox.access.RequestEmailConfirmationRequest) returns (google.protobuf.Empty);
     */

  }, {
    key: "requestEmailConfirmation",
    value: function requestEmailConfirmation(input, options) {
      var method = this.methods[12],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Метод подтверждения почты
     *
     * @generated from protobuf rpc: ConfirmEmail(grpc.edox.access.ConfirmEmailRequest) returns (google.protobuf.Empty);
     */

  }, {
    key: "confirmEmail",
    value: function confirmEmail(input, options) {
      var method = this.methods[13],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Метод смены логина
     * JWT-Authentication
     *
     * @generated from protobuf rpc: ChangeLogin(grpc.edox.access.ChangeLoginRequest) returns (google.protobuf.Empty);
     */

  }, {
    key: "changeLogin",
    value: function changeLogin(input, options) {
      var method = this.methods[14],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Метод проверки занятости логина
     * JWT-Authentication
     *
     * @generated from protobuf rpc: CheckLoginInUse(grpc.edox.access.CheckLoginInUseRequest) returns (grpc.edox.access.CheckLoginInUseResponse);
     */

  }, {
    key: "checkLoginInUse",
    value: function checkLoginInUse(input, options) {
      var method = this.methods[15],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Метод смены пароля
     * JWT-Authentication
     *
     * @generated from protobuf rpc: ChangePassword(grpc.edox.access.ChangePasswordRequest) returns (google.protobuf.Empty);
     */

  }, {
    key: "changePassword",
    value: function changePassword(input, options) {
      var method = this.methods[16],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Метод подтверждения учетной записи
     * JWT-Authentication
     *
     * @generated from protobuf rpc: VerifyAccount(grpc.edox.access.VerifyAccountRequest) returns (grpc.edox.access.VerifyAccountResponse);
     */

  }, {
    key: "verifyAccount",
    value: function verifyAccount(input, options) {
      var method = this.methods[17],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Метод получения информации об аккаунте пользователя
     * JWT-Authentication
     *
     * @generated from protobuf rpc: GetUserAccountInfo(grpc.edox.access.GetUserAccountInfoRequest) returns (grpc.edox.access.GetUserAccountInfoResponse);
     */

  }, {
    key: "getUserAccountInfo",
    value: function getUserAccountInfo(input, options) {
      var method = this.methods[18],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
  }]);

  return AccessApiClient;
}();